import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function create(data) {
    const url = `${HOST}/cps-gateway/api/v1/partner/create`;

    return request({ method: 'post', url: url }, data);
}

export async function contractList(data) {
    const url = `${HOST}/cps-gateway/api/v1/partner/contract/list`;

    return request({ method: 'get', url: url });
}

